import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

const useUserUid = () => {
  const { instance, inProgress } = useMsal();
  const account = instance.getActiveAccount();

  // No account is expected while MSAL is still processing a redirect/login
  // (e.g. right after the auth callback) — only warn once that's settled.
  if (account == null && inProgress === InteractionStatus.None) {
    console.error('Should not call useUserUid on an unauthenticated user');
  }

  return account?.idTokenClaims?.sub;
};

export default useUserUid;
